import React, { Component } from 'react';

export default class ConfirmationPriceSheetDialog extends Component {

  handleOk = (e) => {
    e.preventDefault();
    this.props.onOk && this.props.onOk();
  };

  render() {
    const { open } = this.props;

    return (
      <div className={"overlayDialog " + (open ? "visible" : "hide")}>
        <div className="blackoutLayer"></div>
        <div className="overlayDialogWindow">
          <p>
            You will receive an email with the price sheet link shortly.
            Please allow up to 30 minutes.
          </p>
          <div className="yesButtonContainer">
            <a className="yesButton blueButton" onClick={this.handleOk}>
              OK
            </a>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/App/components/dialogs/confirmationPriceSheetDialog.js